/**
 * What a sticker's QR code may contain, and what someone may type.
 *
 * Stickers encode a URL so the iPhone's own camera app can open Rotations too:
 *     https://<host>/p/<potId>        e.g. https://rotations.app/p/A1
 * A bare pot number ("A1", "a1 ", "AB12") is accepted from the keypad and from older stickers.
 * Anything else is a code that isn't one of hers (a product barcode, a Wi-Fi QR, ...).
 */

export type PotCode = { readonly kind: "pot"; readonly potId: string } | { readonly kind: "foreign"; readonly raw: string };

const BARE_POT = /^[A-Za-z]{1,2}\d{1,3}$/;

export function normalisePotId(raw: string): string {
  return raw.trim().toUpperCase();
}

export function parsePotCode(raw: string): PotCode {
  const text = raw.trim();
  if (BARE_POT.test(text)) return { kind: "pot", potId: normalisePotId(text) };
  try {
    const url = new URL(text);
    const match = /^\/p\/([A-Za-z]{1,2}\d{1,3})\/?$/.exec(url.pathname);
    if (match?.[1]) return { kind: "pot", potId: normalisePotId(match[1]) };
  } catch {
    // not a URL
  }
  return { kind: "foreign", raw: text };
}
